// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__39zPK","text":"SelectPayment_text__2iiS-","title":"SelectPayment_title__3eWk6","btn":"SelectPayment_btn__FS1ii"};